angular.module('services.newman.UsersService', [
  'global'
])

/**
 * The UsersService service stores methods used to access
 * system APIs.
 *
 * @class UsersService
 * @constructor
 * @module services.newman.UsersService
 */
.factory('UsersService', [
  'GLOBAL',
  'ModelsService',
  'ApiService',
  function (GLOBAL, ModelsService, ApiService) {
    'use strict';

    var service = {

      current: null,

      users: [],

      /**
       * Returns users.  If a userId is
       * provided will return a single user.  If no
       * userId is provided will return all users.
       *
       * @param {string} [userId] - return only a specific user
       * @param {string} [email] - return only a specific user
       * @return {Object|Array<Object>} All entries
       */
      get: function get(userId, email) {
        var ret;

        service.users = ModelsService.read('users');

        if (userId || email) {
          ret = _.find(service.users, function (obj) {
            if (userId) {
              return obj.id === userId;
            }
            if (email) {
              return obj.content.email === email;
            }
            return false;
          });
        } else {
          ret = service.users;
        }

        return ret;
      },

      /**
       * Create a user based on provided model
       *
       * @param {Object} model - User model
       * @return {Promise<Object>} User model
       */
      create: function create(model) {
        console.log(model);
        model.content.groups = model.content.groups.split(',');
        return ModelsService.create(ModelsService.find('endpoints', 'label', 'users'), model);
      },

      /**
       * Remove a user based on provided ID
       *
       * @param {Object} id - User ID
       * @return {Array<Object>} All users
       */
      remove: function remove(id) {
        service.users = _.reject(service.users, { id: id });
        console.log(service.users);
        return service.users;
      },

      /**
       * Sets the current user based on provided user model
       *
       * @param {Object} user - User model
       */
      setCurrent: function setCurrent(user) {
        service.current = user;
      },

      /**
       * Gets the current user
       *
       * @return {Object} Current user model
       */
      getCurrent: function getCurrent() {
        return service.current;
      },

      /**
       * Returns a user model template
       *
       * @return {Object} Empty user model template
       */
      getNew: function getNew() {
        return {
          label: 'user-' + uuid.v1(),
          content: {
            changepw: true,
            email: '',
            groups: [''],
            roles: {
              admin: false,
              author: false,
              qa: false
            },
            userId: null,
            contextId: null,
            role: null,
            firstName: '',
            lastName: ''
          }
        };
      },

      /**
       * Executed API call to reset password.  Upon
       * resetting the password an email is sent
       * to the user with a temporary password.  On first login
       * they are prompted to change password.
       *
       * @param {string} userId - User identifier
       * @return {Promise<*>} confirmation
       */
      resetPassword: function resetPassword(userId) {
        return ApiService.execute(GLOBAL.apiPath + '/auth/passwords/' + userId, 'DELETE', null);
      }

    };

    return service;
  }
]);
